package org.hs_soft.runmynesto.domain.model.home.home.user_profile_info


import kotlinx.serialization.SerialName
import kotlinx.serialization.Serializable

@Serializable
data class User(
    @SerialName("avatarUrl")
    val avatarUrl: String?,
    @SerialName("email")
    val email: String?,
    @SerialName("locale")
    val locale: String?,
    @SerialName("name")
    val name: String?,
    @SerialName("sub")
    val sub: String?
)